import { Transfer } from 'antd';
import { useEffect, useState } from 'react';
import { useStore } from '../../store/store';
import { addStylesheetURLPreview, fontsUrlBuilder, getPrimaryDark } from '../../constants/constants';
import { searchInputWidth } from '../../constants/gridConfig';
import { hexToRgba } from '../../utils/theme';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { fetchGoogleFontFamilies } from '../../shared/fonts/googleFonts';

const selector = ({
  changeFontFamilyListInConfig,
  configuration,
  currentDocument,
}) => ({
  changeFontFamilyListInConfig,
  selectedFontFamilies: configuration.fontFamilyList,
  accentColor: getPrimaryDark(currentDocument?.type === 'template'),
});

export const FamilyPicker = ({ selectFamily }) => {
  const { changeFontFamilyListInConfig, selectedFontFamilies, accentColor } = useStore(selector);
  const [fontFamilyListFromApi, setFontFamilyListFromApi] = useState([]);//list of items from api call
  const [localFamilyList, setLocalFamilyList] = useState([]);//list transmitted to transfer component
  const { t } = useTranslation();
  // const [inputFamilyName, setInputFamilyName] = useState('');

  const getFonts = async () => {
    setFontFamilyListFromApi(await fetchGoogleFontFamilies());
  };

  useEffect(() => {
    if (fontFamilyListFromApi.length <= 0) { getFonts(); }
    setLocalFamilyList(fontFamilyListFromApi);
  }, [fontFamilyListFromApi])

  const onChange = (newFamiliesKeys, _direction, _moveKeys) => {
    changeFontFamilyListInConfig(newFamiliesKeys.map((familyKey) => fontFamilyListFromApi.find((f) => f.key === familyKey)));
  };

  const filterOption = (inputValue, option) => _.capitalize(option.familyName).indexOf(_.capitalize(inputValue)) > -1;

  return (
    <Transfer
      className={selectedFontFamilies.length > 1 ? '' : 'transfer-remove-icon'}
      showSelectAll={false}
      dataSource={localFamilyList}
      targetKeys={selectedFontFamilies.map((f) => f.key)}
      showSearch
      titles={[t('accessible-fonts'), t('selected-fonts')]}
      onChange={onChange}
      filterOption={filterOption}
      locale={{
        itemUnit: t('font'),
        itemsUnit: t('fonts'),
        searchPlaceholder: t('search-font'),
        notFoundContent: t('no-font'),
      }}
      render={(item) =>
        <div
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => {
            addStylesheetURLPreview(fontsUrlBuilder([item]));
            selectFamily([item.familyName]);
          }}
          style={{ fontFamily: `${item.familyName}` }}
        >
          {item.familyName}
        </div>
      }
      oneWay={true}
      // Bordure pastel sur la liste des polices retenues pour la distinguer
      // d'un coup d'œil de celle des polices disponibles.
      listStyle={({ direction }) => ({
        width: searchInputWidth,
        height: 300,
        ...(direction === 'right' && { borderColor: hexToRgba(accentColor, 0.35) }),
      })}
    />
  );
};
